import { MultiSelectFilterType } from './multi-select-filter-type';
import { DataManager } from '@syncfusion/ej2-data';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
import { DropDownConstantsFactory } from '../syncfusion/dropdown-constants-factory';
import { MultiSelectCustomAdaptor } from './multi-select-custom-adaptor';
import { Observable } from 'rxjs';
import { MultiSelectItem } from './multi-select-item';
import { MultiSelectComponent, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-multi-select-filter',
    templateUrl: './multi-select-filter.component.html',
    styleUrls: ['./multi-select-filter.component.scss'],
    imports: [MultiSelectModule, TranslateModule]
})
export class MultiSelectFilterComponent implements OnInit, OnChanges, AfterViewInit {
  @Input()
  public getDataFunction: (searchText: string) => Observable<string[] | MultiSelectItem[]>

  @Input()
  public type: MultiSelectFilterType;

  @Input()
  public isDisabled = false;

  @Input()
  public placeholder = '';

  @Input()
  public set values(values: any[]) {
    // set values to 'null' to force reset with data reload
    this._outputValue = values;
  }

  @Output()
  public valuesChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  @ViewChild('multiselect')
  public multiselect: MultiSelectComponent;

  public data: DataManager;

  public get outputValue() {
    return this._outputValue;
  }

  public set outputValue(value: any[]) {
    this._outputValue = value;
    if (this._isInitialized && this._outputValue != null) {
      this.valuesChange.emit(this._outputValue);
    }
  }

  public refreshData() {
    this._outputValue = null;
    if (this.multiselect) {
      this.multiselect.refresh();
    }
  }

  public fieldsSettings = undefined;

  private _outputValue: any[] = [];
  private _isInitialized: boolean = false;

  constructor() {
  }

  ngOnInit() {
    if (this.type === MultiSelectFilterType.MultiSelectItem) {
      this.fieldsSettings = DropDownConstantsFactory.createStandardClientDropdownSettings();
    }
    this.data = new DataManager({
      adaptor: new MultiSelectCustomAdaptor(this.getDataFunction)
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.isDisabled && changes.isDisabled.currentValue != null) {
      if (this.multiselect) {
        this.multiselect.setDisabledState(this.isDisabled)
      }
    }
  }

  ngAfterViewInit() {
    this._isInitialized = true;
  }

}
